module.exports = __webpack_public_path__ + "img/riseup-logo.02fc6d42.svg";